import { useMutation, useQueryClient } from '@tanstack/react-query';

import { EmailVerificationEventAdapter } from '~analytics/adapters/EmailVerificationEventAdapter';

import { verifyEmail } from '../../../api/account';
import { accountKeys } from './useAccount';

export function useVerifyEmail() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: verifyEmail,
    onSuccess: () => {
      // Analytics
      new EmailVerificationEventAdapter().sendAnalytics();

      // Must invalidate the account query since this is where the verification status is stored
      queryClient.invalidateQueries({ queryKey: accountKeys.account });
    },
  });
}
